/**
 * Clave de consulta de las justificaciones del trabajador (008 · T111; contracts/staff-api.md S2).
 *
 * Módulo sin dependencias, como `regularization/keys.ts` y `schedule/keys.ts`: `./api.ts` la
 * reexporta y cualquier vista puede importarla sin crear ciclos.
 */
export const STAFF_JUSTIFICATIONS_QUERY_KEY = ['staff-justifications'] as const;
